export default {
    apiKey: 'AIzaSyDJg3PIsIlyXKv3-cc44ZKsyMxfObUl3Iw',
    authDomain: 'vanload-fife.firebaseapp.com',
    databaseURL: 'https://vanload-fife.firebaseio.com',
    projectId: 'vanload-fife',
    storageBucket: 'vanload-fife.appspot.com',
    messagingSenderId: '1036467629706'
}
